module.exports = __webpack_public_path__ + "img/landing_product_thumbnail.3628714b.jpg";